import React from 'react';
import PropTypes from "prop-types";
import { Container, Grid, Segment, Header } from "semantic-ui-react";

import ContactItem from "./ContactItem.js";
import Footer from "../Footer/Footer.js";

import './Contact.css';

const splitIntoRows = (contactItems) => {
  let items = Array.from(contactItems);
  let rows = [];
  while (items.length) {
    let newRow = items.splice(0, 4);
    rows.push(newRow);
  }
  return rows;
}

const Contact = ({ copy }) => {
  const columnsCount = 4;
  const gridRows = splitIntoRows(copy.contactItems);
  return (
    <Segment basic inverted id='contact-section' color='grey'>
      <Container>
        <Container fluid textAlign='center'>
          <Header as='h1' inverted>Get in touch</Header>
          <p>{copy.subheader}</p>
        </Container>
        <Grid stackable columns={columnsCount} className='contact-grid'>
          {gridRows.map((row, i) => {
            return (
              <Grid.Row key={`contact_row_${i}`}>
                {row.map((item) => {
                  return (
                    <Grid.Column key={`column_${item.name}`}>
                      <ContactItem item={item} />
                    </Grid.Column>
                  );
                })}
              </Grid.Row>
            );
          })}
        </Grid>
      </Container>
      <Footer />
    </Segment>
  );
};

export default Contact;

Contact.propTypes = {
  copy: PropTypes.shape({
    subheader: PropTypes.string.isRequired,
    contactItems: PropTypes.arrayOf(
      PropTypes.shape({
        iconName: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired,
        link: PropTypes.string
      })
    )
  })
}


// WEBPACK FOOTER //
// ./src/Contact/Contact.js